import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRightIcon, TimerIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[100svh] flex flex-col justify-center items-center px-4 py-6 sm:py-12 overflow-hidden bg-brand-dark" data-id="element-14">
      {/* Background Grid Effect */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f2937_1px,transparent_1px),linear-gradient(to_bottom,#1f2937_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20 pointer-events-none" data-id="element-15" />

      {/* Volt Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-brand-volt/10 blur-[120px] rounded-full pointer-events-none" data-id="element-16" />

      <div className="max-w-5xl mx-auto text-center relative z-10 flex flex-col items-center mt-4 sm:mt-10" data-id="element-17">
        <FadeIn direction="down" data-id="element-18">
          <div className="inline-flex items-center gap-2 bg-brand-surface border border-brand-muted/30 px-4 py-2 rounded-full mb-4 sm:mb-8" data-id="element-19">
            <span className="flex h-2 w-2 relative" data-id="element-20">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-volt opacity-75" data-id="element-21"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-volt" data-id="element-22"></span>
            </span>
            <span className="text-sm font-medium text-brand-muted uppercase tracking-wider" data-id="element-23">
              Oferta de Lanzamiento Activa
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-24">
          <h1 className="text-4xl sm:text-7xl md:text-8xl font-black text-white mb-4 sm:mb-6 leading-[0.95] sm:leading-[0.9] tracking-tighter text-balance" data-id="element-25">
            Solucioná tus clases <br className="hidden sm:block" data-id="element-26" />
            de Trail Running{' '}
            <span className="text-brand-volt" data-id="element-27">con este Mega Pack.</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-28">
          <p className="text-base sm:text-2xl text-gray-300 font-medium mb-5 sm:mb-8 max-w-3xl mx-auto leading-relaxed text-balance normal-case" data-id="element-29">
            El sistema completo para profes, entrenadores y coaches que quieren
            dar clases de trail running sin pasar horas planificando desde cero.
            6 tomos, recursos listos y 5 bonos para aplicar desde tu próxima
            clase.
          </p>
        </FadeIn>

        <FadeIn delay={0.25} className="w-full max-w-2xl mx-auto mb-5 sm:mb-8" data-id="element-30">
          <div className="relative rounded-xl overflow-hidden border border-brand-muted/20 bg-brand-surface/50" data-id="element-31">
            <img src="https://cdn.magicpatterns.com/uploads/275M62sCXzYmq1YejSah6t/imagen_trail.png" alt="Mega Pack Trail Running para Profes — tomos, bonos y equipamiento" className="w-full h-auto object-contain max-h-[180px] sm:max-h-[340px]" data-id="element-32" />
          </div>
        </FadeIn>

        <FadeIn delay={0.3} className="w-full max-w-md mx-auto flex flex-col gap-4" data-id="element-33">
          <a href="#oferta" className="group relative w-full bg-brand-volt hover:bg-brand-voltHover text-white font-display rounded-xl px-6 py-4 sm:px-8 sm:py-5 flex items-center justify-center transition-all transform hover:-translate-y-1 shadow-[8px_8px_0px_rgba(255,255,255,0.1)] hover:shadow-[12px_12px_0px_rgba(59,130,246,0.3)]" data-id="element-34">
            <span className="flex items-center gap-3 font-black text-xl sm:text-2xl tracking-wide" data-id="element-35">
              QUIERO EL MEGA PACK
              <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" strokeWidth={3} data-id="element-36" />
            </span>
          </a>

          <div className="flex items-center justify-center gap-2 text-brand-muted text-sm font-medium mt-2" data-id="element-37">
            <TimerIcon className="w-4 h-4" data-id="element-38" />
            <span data-id="element-39">Acceso inmediato • Pago único de $26.990 ARS</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}